const Range = (start, end) => {
    let result = [];
    for (let i = start; i <= end; i++) {
        result.push(i);
    }
    return result;
};
export { Range };
export default Range;
